import Ready from '../../js/utils/ready';

Ready(() => {
  if (window.Confirmic) {
    window.Confirmic('ConsentManager:onShow', () => {
      setTimeout(
        () => {
          window.scrollTo(0, 0);
        }, 500,
      );
    });
  }
});
